<template>
  <div class="dialogEffect">
    <el-dialog :title="$t('text.confirmation')" :visible.sync="dialogVisible" :show-close="cancelVisible" :close-on-click-modal="cancelVisible" width="30%" :before-close="handleClose">
      <el-form ref="dialogForm" :rules="rules" :model="createData" label-width="120px">
        <el-col v-for="(item, index) in data" :key="index" :span="24">
          <div class="el-dialog__flex" v-if="item.type === 'tip'">
            <div>{{item.name}}</div>
          </div>
          <div class="el-dialog__flex" v-else-if="item.type === 'normal'">
            <div class="label">{{item.name}}:</div>
            <div>{{ item.value }}</div>
          </div>
          <el-form-item v-else :label="item.name" :prop="item.key">
            <el-input type="textarea" v-if="item.type === 'text_field'" :placeholder="item.hint" v-model="createData[item.key]"></el-input>
            <el-input type="number" v-if="item.type === 'number'" :placeholder="item.hint" v-model="createData[item.key]"></el-input>
            <el-checkbox type="number" v-if="item.type === 'checkbox'" :placeholder="item.hint" v-model="createData[item.key]"></el-checkbox>
            <el-radio-group v-if="item.type === 'radio'" :placeholder="item.hint" v-model="createData[item.key]">
              <el-radio v-for="option in item.options"
                :border="false"
                :disabled="false"
                :key="option['value']"
                :label="option['value']">
                {{ option['name'] }}
              </el-radio>
            </el-radio-group>
            <el-input v-if="item.type === 'text'" :placeholder="item.hint" v-model="createData[item.key]"></el-input>
            <el-select clearable style="width:100%" :placeholder="item.hint" v-if="item.type === 'select'" v-model="createData[item.key]">
              <el-option v-for="option in item.options" :key="option[item.option_key ? item.option_key : 'value']" :label="option[item.option_label ? item.option_key : 'name' ]" :value="option[item.option_value ? item.option_value : 'value']"></el-option>
            </el-select>
            <el-date-picker value-format="yyyy-MM-dd" :picker-options="pickerOptions" :disabledDate="disabledDate" style="width:100%" type="date" v-if="item.type === 'date'" :placeholder="item.hint" v-model="createData[item.key]"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose" v-if="cancelVisible">{{$t('button.cancel')}}</el-button>
        <el-button type="primary" @click="handleClick">{{buttonText}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Utils from '@/utils/Utils'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default () {
        return false
      }
    },
    data: {
      type: Array,
      default () {
        return []
      }
    },
    dateArray: {
      type: Array,
      default () {
        return []
      }
    },
    todayVisible: {
      type: Boolean,
      default () {
        return false
      }
    },
    opereteDate: {
      type: Boolean,
      default () {
        return false
      }
    },
    cancelVisible: {
      type: Boolean,
      default () {
        return true
      }
    },
    buttonText: {
      type: String,
      default () {
        return this.$t('button.confirm')
      }
    }
  },
  data () {
    const $this = this
    return {
      pickerOptions: {
        disabledDate (time) {
          if ($this.opereteDate) {
            let visible = true
            $this.dateArray.some(item => {
              if (item.date === Utils.getTime(new Date(time.getTime()))) {
                visible = false
                return true
              }
            })
            return visible
          } else if ($this.todayVisible) {
            if (Utils.compareTime(Utils.getTime(new Date()), Utils.getTime(new Date(time.getTime())))) {
              return false
            } else {
              return true
            }
          } else {
            return true
          }
        }
      },
      rules: {},
      createData: {}
    }
  },
  created () {
    this.bindData()
  },
  methods: {
    handleClose () {
      this.$emit('update:dialogVisible', false)
      this.$emit('cancle', {})
    },
    bindData () {
      if (this.data.length > 0) {
        this.data.forEach(item => {
          if (item.type === 'normal' || item.type === 'tip') return
          this.$set(this.createData, item.key, !Utils.isNull(item.value) ? item.value : '')
          this.$set(this.rules, item.key, [{ required: (Utils.isNull(item.optional) || item.optional === true), message: this.$t('text.require', { name: item.name }), trigger: ['blur', 'change'] }])
        })
      }
    },
    handleClick () {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          this.handleClose()
          this.$emit('doNextConfirm', this.createData)
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    disabledDate () {
      return false
    }
  }
}
</script>

<style lang="scss">
.dialogEffect {
  .el-form-item__label {
    word-break: break-word;
  }
  // .el-form-item--small .el-form-item__label {
  //   line-height: 24px;
  // }
  .el-dialog__header {
    padding: 10px;
    border-bottom: 1px solid #dcdfe6;
    .el-dialog__title {
      font-size: 16px;
      line-height: 16px;
    }
    .el-dialog__headerbtn {
      top: 10px;
      right: 10px;
    }
  }
  .el-dialog__body {
    min-height: 200px;
    padding: 10px 20px;
  }
  .el-dialog__footer {
    text-align: right;
    padding: 10px 20px;
  }
  .el-dialog__flex {
    display: flex;
    margin-bottom: 8px;
  }
  .label {
    width: 120px;
    text-align: right;
    margin-right: 3px;
  }
}
</style>
